import React from 'react'

export default class TermsMaui2019 extends React.Component {
  render() {
    return (
      <div className="policy">
        {!this.props.hideExtras && (
          <h1>Everlasting Tours Agreement | Maui 2019</h1>
        )}
        <hr />
        <h3>Services</h3>
        <p>
          Everlasting Tours (Everlasting) shall contract with hotel(s) and other
          business establishments so as to provide the Traveler with the items
          listed in the Trip Includes section of the flyer/brochure/website. In
          the event of cancellations by the hotel or if the number of travelers
          Everlasting deems necessary to provide the trip is not reached,
          Everlasting shall have the right, without liability to the Traveler,
          to either contract with alternate hotels of equal or greater quality
          without penalty or at no additional cost to the Traveler, or to refund
          Traveler all amounts paid to Everlasting by Traveler in which event
          Everlasting shall have no further liability to Traveler. Everlasting
          does not own or operate any person or entity which is to provide goods
          or services for the Traveler’s trip including, for example,
          accommodations, air, land, rail, water or other transportation, food
          service, local guides, etc. As a result, if these services or
          components are prevented, restricted or interfered with by reason of
          causes beyond Everlasting’s control, including without limitation,
          acts of civil or military authorities, by reason of statute, rule, or
          action of federal, state or local government or agency, acts of public
          enemy, acts of terrorism, criminal activity, war, riot, embargoes,
          civil commotion, insurrection, strike or labor unrest, acts of God,
          attacks by animals, severe weather conditions, storm, flood, fire,
          earthquake, power or communication line failure, sickness, food
          poisoning, unsafe sanitary conditions, quarantine, acts or omissions
          of carriers including but not limited to breach of contract,
          cancellation, delay or over booking, acts or omissions of other
          providers such as hotels, local ground handlers, entertainers or
          sightseeing services or restaurants including but not limited to
          breach of contract, cancellation, delay or over booking, or Traveler’s
          negligence, Everlasting shall not be liable for any claims, losses,
          damages (direct, indirect, consequential or incidental), costs, or
          expenses including without limitation, injury, accident or death,
          inconvenience, loss of enjoyment, loss of pay, or emotional distress,
          whether physical or mental, arising out of or in connection therewith.
          Everlasting recommends that you visit the websites of the Department
          of Transportation (www.dot.gov) and the Federal Aviation
          Administration (www.faa.gov) for current news and releases regarding
          air travel and safety. Everlasting reserves the right to make changes
          in the published itinerary whenever, in its judgment, conditions
          warrant, or if it deems it necessary for the comfort, convenience, or
          safety of the trip. Baggage and personal effects are solely the
          responsibility of the Traveler.
        </p>
        <h3>Cancellation by Speakers or Artists</h3>
        <p>
          Everlasting shall not be liable for the failure of any speaker or
          other artist or musician to attend or to perform during the trip. In
          the event of any failure of any speaker or artist to perform during
          the trip, Everlasting, at its sole discretion, may engage a
          replacement artist or artists, change, postpone, or terminate any
          portion of the entertainment program. In such case, Everlasting shall
          have no liability to any passenger for any loss, damage, or expense
          whatsoever by reason of such change.
        </p>
        <h3>Changes in Bookings</h3>
        <p>
          Revisions or alterations made to a reservation after the booking is
          confirmed will incur a fee of $50 per person (per change), unless the
          change increases the value of the booking. Corrections to name
          spellings can be made up until 45 days prior to the trip. Traveler
          shall notify Everlasting for any changes in address, telephone number,
          or email address prior to the trip commencement date. Everlasting is
          not liable for misdirected mail, telephone calls, or email.
        </p>
        <h3>Payments</h3>
        <p>
          Passengers may choose to pay for their reservation in full or use a
          monthly payment plan. All payments must be made by automatic credit
          card draft. For monthly payment plans, a one-time $40 convenience fee
          (per person) will be added to the total amount due. Monthly payments
          start at the time of booking and continue until the account is paid in
          full. Account must be paid in full no later than September 18, 2019.
          The first payment is non-refundable at the time of booking and any
          future payments are subject to the cancellation policy as outlined
          below. If an automatic payment is unsuccessful for 21 days, the
          payment plan will have failed and the reservation will be subject to
          cancellation unless reinstated with payment. It is the sole
          responsibility of the cardholder to contact Everlasting and restart
          the agreed upon payment plan. All delinquent payments are due at that
          point in time. A late fee of $30 will be assessed to the account for
          the declined charge. A fee of $30 will be charged to change a payment
          plan after it has begun, as in the case of a passenger requiring that
          we stop payments from occurring on one card and start payments on a
          different card.
        </p>
        <h3>Cancellation Charges | Cancellations/Refunds</h3>
        <p>
          Each passenger acknowledges that the Everlasting Tours Cancellation
          Policy supersedes the policies of any and all outside vendors’
          policies. To cancel your reservation you must send us written notice
          (by mail or fax) to: Everlasting Tours, Attn: Cancellations, PO Box
          1707, Medford, OR 97501 or fax # (888) 781- 8687. Everlasting
          recommends that you purchase delivery confirmation (if mailing) or
          printing off a fax confirmation (if faxing). It is the traveler’s
          responsibility to confirm that the cancellation has been received by
          Everlasting.
        </p>
        <p>
          If you do not make payments as agreed upon, your reservation will be
          subject to cancellation and cancellation fees will apply.
        </p>
        <p>
          If you fail to appear on the trip, regardless of the reason, your
          reservation will be cancelled.
        </p>
        <p>
          Each passenger expressly acknowledges that because of the special
          nature of the event and the additional expenses incurred by
          Everlasting related to cancellation, re-booking, potential lost
          revenue, and finding booking replacements, that Everlasting will
          suffer damages and expenses. The parties agree that the liquidated
          damages provisions shown in the table below represent a fair,
          reasonable and agreed upon determination of those damages and expenses
          and will apply regardless of the reason for cancellation, even those
          due to unexpected or special circumstances.
        </p>
        <ul>
          <li>
            From time of reservation to August 31, 2018 - First monthly payment
            or the equivalent for the room category selected, if paid in full,
            plus 100% of any other fees.
          </li>
          <li>
            From September 1, 2018 to October 31, 2018 - 25% of Trip Price and
            additional room night charges (if applicable), plus 100% of any
            other fees.
          </li>
          <li>
            From November 1, 2018 to April 30, 2019 - 50% of Trip Price and
            additional room night charges (if applicable), plus 100% of any
            other fees.
          </li>
          <li>
            From May 1, 2019 until the date of the trip - 100% of Trip Price and
            additional room night charges (if applicable), plus 100% of any
            other fees.
          </li>
        </ul>
        <p>
          No refunds for no shows or when cancelled after May 1, 2019. After
          cancellation fees are incurred, if there is a remaining balance due,
          Everlasting may, in its sole discretion, consider your notice of
          cancellation to be invalid and thus may not release your reservation
          until payment of the cancellation charges is received; therefore a
          delay in payment may result in a higher cancellation fee being owed.
          If a refund is due, Everlasting will credit a refund within 60 days of
          receipt of the written request for cancellation.
        </p>
        <p>
          Passenger expressly acknowledges that Everlasting highly recommends
          travel/cancellation insurance for each and every passenger. It is the
          sole responsibility of each passenger to purchase travel /
          cancellation insurance.
        </p>
        <h3>Documentation</h3>
        <p>
          A valid drivers license, government issued photo id, or passport is
          required for hotel check-in. For Cancun, a passport is required to
          enter/leave the country. Any guest traveling without proper
          documentation will not be allowed to check-in at the resort and no
          refund of the trip price will be issued. A valid credit card must be
          presented to hotel upon guest check-in.
        </p>
        <h3>Trip Price</h3>
        <p>
          Prices are based on double occupancy and include 7 days/6 nights
          resort accommodations (in the room category of your choice) and
          include what’s listed under the "Love Song Couples Getaway Includes"
          section.
        </p>
        <h3>Other Charges</h3>
        <p>
          Optional travel/cancellation insurance, meals, laundry, clothing, room
          service, telephone charges, optional activities, local transportation
          including ground transportation, side trips, airline tickets,
          incidental hotel charges (a valid credit card will be required at
          check-in), and all other items not expressly listed in the Trip
          Includes section.
        </p>
        <h3>Traveler Responsibility</h3>
        <p>
          Each Traveler is responsible for all of his or her actions from the
          departure flight until arrival back to the departure city.
        </p>
        <h3>Handicap Accessibility</h3>
        <p>
          Hotels, transportation services, and other facilities are not
          necessarily handicap accessible. If the Traveler has a disability,
          which may require special assistance, the Traveler must notify us in
          advance in writing.
        </p>
        <h3>Photography | Sharing of Information</h3>
        <p>
          Everlasting and/or its promotional partners have the exclusive right
          to include photographic, video and other visual portrayals of
          passengers in any medium of any nature whatsoever for the purpose of
          trade, advertising, sales, publicity or otherwise, without
          compensation to passengers, and all rights, title and interest therein
          shall be Everlasting sole property, free from any claims by passengers
          or any person deriving any rights or interest from a passenger.
        </p>
        <h3>Miscellaneous</h3>
        <p>
          It is agreed by and between the passenger(s) and Everlasting that this
          entire agreement supersedes all prior representations, agreements or
          understandings of the parties. All disputes and matters whatsoever
          arising under, in connection with or incident to this Agreement, shall
          be construed and governed by the laws of the State of Oregon and is
          deemed to be made and entered into in Jackson County, Oregon wherein
          the Circuit Court of the State of Oregon shall have exclusive
          jurisdiction in a dispute arising under this Agreement. In the event
          of a dispute between the parties, the prevailing party shall be
          entitled to be paid the reasonable attorney fees and costs by the
          losing party, both in the Circuit Court and on appeal.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/terms-maui2019.js